"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubscriptionCard = exports.StyledDiscountBadge = exports.StyledSubscriptionCardGroup = exports.StyledDescription = exports.StyledSubTitleWrapper = exports.StyledSubTitle = exports.StyledTitle = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("./subscription-card.types");
exports.StyledTitle = theme_1.styled.div `
  ${theme_1.typography.medium32};
  ${theme_1.mixins.flex({ alignItems: 'center' })};
  color: ${({ theme }) => theme.colors.text.primary};
`;
exports.StyledSubTitle = theme_1.styled.div `
  ${theme_1.typography.medium20};
  ${theme_1.mixins.flex({ alignItems: 'center', wrap: false, gap: 8 })};
  color: ${({ theme }) => theme.colors.text.secondary};
`;
exports.StyledSubTitleWrapper = theme_1.styled.div `
  ${theme_1.mixins.flex({
    alignItems: 'flex-start',
    wrap: false,
    gap: 10,
    justifyContent: 'space-between',
})};
  width: 100%;
`;
exports.StyledDescription = theme_1.styled.div `
  ${theme_1.typography.regular16};
  line-height: 24px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
exports.StyledSubscriptionCardGroup = theme_1.styled.div `
  ${theme_1.mixins.flex({ gap: 16 })};
`;
exports.StyledDiscountBadge = theme_1.styled.div `
  ${theme_1.typography.regular16};
  line-height: 24px;
  padding: 2px 10px;
  border-radius: calc(${({ theme }) => theme.common.radius} * 4);
  background: ${({ theme, discountBadgeColor }) => { var _a, _b, _c; return discountBadgeColor || ((_c = (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.accent) === null || _b === void 0 ? void 0 : _b.success) === null || _c === void 0 ? void 0 : _c.normal); }};
  color: ${({ theme }) => theme.colors.text.inverse};
`;
exports.StyledSubscriptionCard = theme_1.styled.label `
  ${theme_1.mixins.flex({
    alignItems: 'flex-start',
    wrap: false,
    horizontal: false,
    gap: 8,
})};
  padding: 18px 14px;
  position: relative;
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 2)`; }};
  cursor: pointer;
  user-select: none;
  width: 100%;

  ${({ theme }) => (0, theme_1.css) `
      &:hover {
        border-color: ${theme.colors.neutral[50]};
      }
    `}

  ${theme_1.media.desktop} {
    width: calc(50% - 8px);
  }

  input {
    display: none;
  }

  border: ${({ theme }) => `2px solid ${theme.colors.neutral[30]}`};
  transition: all 0.2s ease-out;
  box-sizing: border-box;
  height: auto;
`;
